module.exports = __webpack_public_path__ + "media/images/ac_banner1-90b31e52e97b5fdbbd9558e990e34f24.png";